import apiService from "./apiServices";

export const getTaskNotification = async ( page, size,token) => {
    try {
      const response = await apiService(`/notifications/tasks?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

export const getSmsNotification = async ( page, size,token) => {
    try {
      const response = await apiService(`/notifications/sms/unread?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

export const getNotificationCount = async (token,page,size) => {
    try {
      const response = await apiService(`/notifications/total-count?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }


